import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ProBlogPostDetails from 'components/molecules/ProBlogPostDetails';
import ProBlogBreadcrumbs from 'modules/users/modules/blog/components/ProBlogBreadcrumbs';

import { ProBlogPostProps } from 'components/molecules/ProBlogPost';
import { JobType } from 'src/modules/job-types/types';

import { getUserDisplayName } from 'utils/tools';

import styles from './ProBlogPostContent.module.scss';

interface Props {
  blogPost: ProBlogPostProps;
  jobType: JobType;
  pro: {
    id: string;
    location: {
      city?: { key: string; name: string };
      prefecture?: { key: string; name: string };
    };
    name?: string;
    profile: {
      customProfileUrl?: string;
    };
    slug: string;
  };
  slug: string;
}

const ProBlogPostContent: FC<Props> = ({ blogPost, jobType, pro, slug }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const proDisplayName = getUserDisplayName(language, pro.profile);

  return (
    <div className={styles['wrapper']}>
      <ProBlogBreadcrumbs jobType={jobType} pro={pro} proBlogPost={blogPost} />
      <ProBlogPostDetails
        customProfileUrl={pro.profile.customProfileUrl}
        proId={pro.id}
        post={blogPost}
        jobType={jobType}
        proDisplayName={proDisplayName}
        slug={slug}
      />
    </div>
  );
};

export default ProBlogPostContent;
export type { Props as ProBlogPostContentProps };
